import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const GlobalContext = createContext({});

export function GlobalProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const toastId = useRef(0);

  // Theme: dark = true (default)
  const [isDark, setIsDark] = useState(true);
  const toggleTheme = () => {
    setIsDark(prev => {
      const next = !prev;
      document.documentElement.classList.toggle('dark', next);
      return next;
    });
  };

  // Global dialog states by key
  const [dialogs, setDialogs] = useState({});
  const openDialog  = (key, payload = true) => setDialogs(prev => ({ ...prev, [key]: payload }));
  const closeDialog = (key) => setDialogs(prev => ({ ...prev, [key]: false }));
  const toggleDialog = (key, payload = true) => setDialogs(prev => ({ ...prev, [key]: prev[key] ? false : payload }));

  // Toast system
  const showToast = useCallback((type, title, message, duration = 4000) => {
    const id = ++toastId.current;
    setToasts(prev => [...prev, { id, type, title, message }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  const dismissToast = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <GlobalContext.Provider value={{
      isDark, toggleTheme,
      dialogs, openDialog, closeDialog, toggleDialog,
      toasts, showToast, dismissToast,
    }}>
      {children}
    </GlobalContext.Provider>
  );
}

export const useGlobal = () => useContext(GlobalContext);
